import { useState } from "react";
import { useParams } from "react-router-dom";
import ActionCard from "@/components/ActionCard";
import SectionHeading from "@/components/SectionHeading";
import { useCanAccessPhotoboothBool, useHasRoles } from "@/hooks/useCapabilities";
import { ROLE } from "@/providers/AuthorizationProvider/types";
import { usePhotoboothOptional } from "@/features/photobooth";
import useAmplitude from "@/hooks/useAmplitude";
import { CCMS_CLICK_EVENT, getCcmsUrl } from "@/features/person/hooks/usePersonActions";
import DataSyncDialog from "../person/_components/DataSyncDialog";

export default function AdminToolsPage() {
  const { pgaId } = useParams();
  const canAccessPhotobooth = useCanAccessPhotoboothBool();
  const isGlobalAdmin = useHasRoles([ROLE.GLOBAL_ADMIN]);
  const photoboothContext = usePhotoboothOptional();
  const { trackEvent } = useAmplitude();
  const [isDataSyncDialogOpen, setIsDataSyncDialogOpen] = useState(false);

  if (!pgaId) return null;

  const handleOpenCCMS = () => {
    trackEvent(CCMS_CLICK_EVENT);
    window.open(getCcmsUrl(pgaId), "_blank");
  };

  return (
    <div className="w-full min-h-[70vh]">
      <SectionHeading heading="Administrative Tools" body="Administrative tools for managing this person's profile" />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-[90rem]">
        {canAccessPhotobooth && photoboothContext && (
          <div className="min-w-0">
            <ActionCard
              actionFn={() => photoboothContext.openPhotoboothByPgaId(pgaId, { source: "admin_tools" })}
              iconName="photo_camera"
              title="Photobooth"
              text="Capture or upload a new profile photo for this person"
              className="max-w-none"
            />
          </div>
        )}
        {isGlobalAdmin && (
          <div className="min-w-0">
            <ActionCard
              actionFn={() => setIsDataSyncDialogOpen(true)}
              iconName="sync"
              title="Data Sync"
              text="Trigger member and education data synchronization from ServiceBus"
              className="max-w-none"
            />
          </div>
        )}
        <div className="min-w-0">
          <ActionCard
            actionFn={handleOpenCCMS}
            iconName="manage_accounts"
            title="Open in CCMS"
            text="View this person's record in the legacy CCMS system"
            trailingIcon="open_in_new"
            className="max-w-none"
          />
        </div>
      </div>

      <DataSyncDialog open={isDataSyncDialogOpen} onClose={() => setIsDataSyncDialogOpen(false)} pgaId={pgaId} />
    </div>
  );
}
